import React, { useContext, useEffect, useRef, useState } from 'react'
import { GlobalContext } from '../global/GlobalProvider';
import { useNavigate } from 'react-router';
import config from '../config';

export default function Sportbook() {
    const initialized = useRef(false);
    const [premiumSports, setPremiumSports] = useState();
    const token = sessionStorage.getItem("token");
    const { isSuccessRes,isErrorRes,openErrorPopup, setAlertMsg } = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        let timer;
        if (isErrorRes) {
          timer = setTimeout(() => {
            window.location.href = '/';
          }, 3000);
        }
        return () => clearTimeout(timer);
      }, [isErrorRes]);

    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;
          callAPI();
        }
      }, [premiumSports]);

    const callAPI = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/premium_sports`, requestOptions)
        .then(async (response) => {
          const responseData = await response.json();
          if (response.ok) {
            setPremiumSports(responseData);
            console.log("premium_sports -", responseData);
          } else {
            // Handle error response
            console.log("API Error:", responseData.message);
            openErrorPopup();
            setAlertMsg(responseData.message); // or setState to display in the UI
          }
        })
        .catch((error) => {
          console.log("Network error:", error.message);
          setAlertMsg("Something went wrong. Please try again later.");
        });
    };
  return (
    <>
    <div className='content-box sportbook'>
      {premiumSports && <iframe
        src={premiumSports.urldata.url} // Replace with the desired URL
        title={'premiumSports'}
        style={{ width: "100%", height: "100%", border: "none" }}
      />}
    </div>
    {/* <div className={`alert ${isSuccessRes ? 'open' : ''}`}><i className="fas fa-check-circle"></i> {alerMsg} </div> */}
    {/* <div className={`alert error ${isErrorRes ? 'open' : ''}`}><i className="fa fa-times-circle" aria-hidden="true"></i> {alerMsg} </div> */}
  </>
  )
}
